export default "__VITE_ASSET__zFbvYYcc__"